<template>
<div class="container-download">
	<v-menu offset-y v-model="menu">
		<v-btn
			slot="activator"
			color="primary"
			dark
			:loading="isLoadLink"
		>
			<v-icon>cloud_download</v-icon> &nbsp;
			{{$t('common.download')}}
		</v-btn>
		<v-list>
			<v-list-tile
				v-for="(item, index) in templates.general"
				:key="index"
				@click="download(item.id)"
			>
				<v-list-tile-title>
					{{ item.template_name }}
				</v-list-tile-title>
			</v-list-tile>
			<v-list-tile
				v-for="(subList, subListIndex) in templates.sub"
				:key="subListIndex"
				class="templates-item"
			>
				<v-list-tile-title>
					<v-menu open-on-hover offset-x class="sub-menu">
						<v-list-tile-title slot="activator">
							{{ subListIndex }}
							<v-icon class="sub-menu-arrow">play_arrow</v-icon>
						</v-list-tile-title>
						<v-list>
							<v-list-tile
								v-for="(subItem, subIndex) in subList"
								:key="subIndex"
								@click="download(subItem.id)"
							>
								{{ subItem.template_name }}
							</v-list-tile>
						</v-list>
					</v-menu>
				</v-list-tile-title>
			</v-list-tile>
		</v-list>
	</v-menu>
	<a
		ref="linkFile"
		v-if="downloadLink != null"
		:href="downloadLink"
		@click="clearDownloadLink"
		class="link-file-hide"
	>
		Download File
	</a>

	<v-dialog v-model="dialog"
		persistent
		max-width="500px"
	>
		<v-card>
			<v-card-title>
				<span class="headline">{{$t('templates.dialog_worker_caption')}}</span>
			</v-card-title>
			<v-card-text>
				<v-container grid-list-md>
					<v-layout wrap>
						<v-flex xs12 d-flex>
							<v-select
								v-model="user_id"
								:items="adminAndManagerUsers"
								:label="$t('templates.dialog_worker_user')"
								item-value="id"
								item-text="name"
							/>
						</v-flex>
					</v-layout>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn color="red darken-1" flat @click="cancel">{{$t('common.close')}}</v-btn>
				<v-btn color="green darken-1" flat @click="send">{{$t('common.download')}}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</div>
</template>

<script>
export default {
	data: vm => ({
		dialog: false,
		user_id: null,
		current_template_id: null,
		menu: false
	}),
	computed: {
		templates() {
			let workerTemplates = this.$store.state.templates.list.filter(
				item => {
					let template_name = item.template_name.split('.')
					return  template_name[0] != 'insurance' ||
							template_name[1] == this.$store.state.workers.workerDetail.insurance_company
				}
			)

			let result = {
				general: [],
				sub: {}
			}
			this.$store.state.templates.list.map(
				item => {
					let template_name = item.template_name.split('.')
					if(template_name.length > 1) {
						item.template_name = template_name[1]
						if(result.sub[template_name[0]] == null) {
							result.sub[template_name[0]] = []
						}
						result.sub[template_name[0]].push(item)
					} else {
						result.general.push(item)
					}
				}
			)
			return result
		},
		downloadLink() {
			return this.$store.state.templates.downloadLink
		},
		isLoadLink() {
			return this.$store.state.templates.isLoadLink
		},
		adminAndManagerUsers() {
			return this.$store.getters['users/adminAndManagerUsers']
		}
	},
	methods: {
		clearDownloadLink() {
			this.$store.dispatch('templates/clearLink')
		},
		download(docId) {
			let configCurrentTemplate = this.$store.state.templates.list.filter(item => item.id == docId)[0].config
			if(configCurrentTemplate.hasOwnProperty('_user_')) {
				this.$store.dispatch('users/fetch', {count: 1000})
				this.current_template_id = docId
				this.dialog = true
			} else {
				this.$store.dispatch('templates/render', {
					tempalteId: docId
				})
			}
			this.menu = false
		},
		cancel() {
			this.dialog = false
		},
		send() {
			this.$store.dispatch('templates/render', {
				tempalteId: this.current_template_id,
				user_id: this.user_id
			})
			this.dialog = false
		}
	},
	updated: function() {
		if (this.downloadLink) {
			this.$refs.linkFile.click()
		}
	}
}
</script>

<style scoped>
.link-file-hide {
	visibility: hidden;
}
.container-download {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}
.sub-menu {
	position: absolute;
	left: 0;
	right: 0;
}
.sub-menu-arrow {
	position: absolute;
	right: 0;
}
.templates-item {
	cursor: pointer;
}
.templates-item:hover {
	background: rgba(0,0,0,.04);
}
</style>
